const V2_LAST_PATH_KEY = "luniapp.v2.lastAllowedPath";
const V2_BASE = "/hotel/lunishower/v2";

export function getV2LastAllowedPath() {
  const stored = sessionStorage.getItem(V2_LAST_PATH_KEY);
  if (stored && stored.startsWith(V2_BASE)) {
    return stored;
  }
  return `${V2_BASE}/dashboard`;
}

export function setV2LastAllowedPath(pathname, search = "") {
  if (!pathname?.startsWith(V2_BASE)) {
    return;
  }
  sessionStorage.setItem(V2_LAST_PATH_KEY, `${pathname}${search || ""}`);
}

export function getV2FallbackPath(locationState) {
  const from = locationState?.from;
  if (typeof from === "string" && from.startsWith(V2_BASE)) {
    return from;
  }
  if (from?.pathname?.startsWith(V2_BASE)) {
    return `${from.pathname}${from.search || ""}`;
  }
  return getV2LastAllowedPath();
}
